const BADGES: string[] = [
  "B2B SaaS",
  "MarTech",
  "Mobile App Marketing",
  "EU-based, US-incorporated",
  "Launched Product",
  "[N] Design Partners",
  "2030 TAM €[NNN]M",
];

export default function Cover() {
  return (
    <div className="flex w-full flex-col gap-10 px-6 pt-10 pb-5 text-slate-900 md:h-full md:gap-0 md:px-24 md:pt-16 md:pb-8">
      <header className="flex">
        <img
          src="https://public.apptonomy.ai/a7y-wordmark-onlight.png"
          srcSet="https://public.apptonomy.ai/a7y-wordmark-onlight.png 1x, https://public.apptonomy.ai/a7y-wordmark-onlight_2x.png 2x, https://public.apptonomy.ai/a7y-wordmark-onlight_3x.png 3x"
          alt="Apptonomy"
          className="h-9 w-auto md:h-12"
        />
      </header>

      <div className="flex flex-col gap-8 md:flex-1 md:flex-row md:items-center md:justify-between md:gap-12">
        <div>
          <h1 className="text-4xl font-semibold leading-tight tracking-tight md:text-7xl md:leading-[1.05]">
            Series Seed
            <br />
            Primer Deck
          </h1>
          <p className="mt-5 text-xs font-semibold uppercase tracking-[0.2em] text-blue-700 md:mt-8 md:text-base md:tracking-[0.25em]">
            The Constant ASO Platform
          </p>
          <p className="mt-2 text-2xl font-semibold leading-tight tracking-tight text-slate-900 md:mt-3 md:text-4xl">
            Expert ASO. Every app. Every day.
          </p>
        </div>
        <div className="flex flex-wrap gap-2 md:flex-col md:items-end md:gap-2.5">
          {BADGES.map((badge) => (
            <span
              key={badge}
              className="rounded-full bg-blue-50 px-3.5 py-1 text-xs font-semibold text-blue-700 ring-1 ring-blue-200 md:px-5 md:py-[7.5px] md:text-[17.5px]/[25px]"
            >
              {badge}
            </span>
          ))}
        </div>
      </div>

      <footer className="text-sm md:text-lg">
        <p className="font-semibold text-slate-800">Thomas Purnell-Fisher, CEO</p>
        <p className="mt-1 text-slate-500">tpf@apptonomy.ai</p>
        <p className="text-slate-500">+31 (0)6 2343 9095 (NL / iMessage / WhatsApp)</p>
      </footer>
    </div>
  );
}
